<template>
    <div>
        <cityinfo-header></cityinfo-header>
        <div class="inner-banner">
            <section class="w3l-breadcrumb">
                <div class="container py-md-4">
                    <div class="title-heading-w3 text-center mx-auto">
                        <h3 class="title-main" >重要業務</h3>
                        <div class="mt-4 sub-title"></div>
                    </div>
                </div>
            </section>
            <section class="w3l-form-26">
                <div class="w3l-new-block-6 py-5">
                    <div class="container py-md-4 py-3">
                        <div class="form-inner-cont">
                            <div class="main-content">
                                <div class="main-content1">
                                    <div class="banner-image-th"></div>
                                    <h3 style="margin-left:20px; margin-bottom:25px; color:#365B6D; font-weight: bold;">簡介</h3>
                                    <div class="summary value-context" v-html="htmlDecode(model.introduction)"></div>
                                </div>
                                <div class="main-content2">
                                    <div class="banner-image-th"></div>
                                    <h3 style="margin-left: 20px; margin-bottom:25px; color:#365B6D; font-weight: bold;">本組重要業務</h3>
                                    <div class="summary value-context" v-html="htmlDecode(model.business)"></div>
                                </div>
                            </div>
                            <div class="row mt-md-5 mt-3">
                                <div class="col-12 text-center">
                                    <div class="btn btn-style">
                                        <button type="button" class="btn" @click="$router.go(-1);">返回</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <cityinfo-footer></cityinfo-footer>
    </div>
</template>
<script>
import header from "./header";
import footer from './footer';
export default {
    props:["id"],
    components:{
        "cityinfo-header":header,
        "cityinfo-footer":footer
    },
    data(){
        return {
            model:{
                introduction:"",
                business:""
            },
        }
    },
    mounted(){
        this.$http.get(`/api/ImportantBusiness/public`).then(a => {
            if(a.body.data){
                this.model = JSON.parse(a.body.data);
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.removeStore(this.$route.name);
		next();
	}
}
</script>
<style>
.value-context > *{
    margin: revert;
    padding: revert;
}
.value-context > * > li{
    list-style-type:revert;
}
</style>